App.GroupTagManipulationComponent = Em.Component.extend
  store: Em.inject.service('store')
  session: Em.inject.service('session')

  classNames: ['group-tag-manipultaion']
  classNameBindings: ['isLoading:loading']

  selectedTagsIds: []
  clientTags: null
  isActionsDisabled: true

  actions:
    toggleTag: (tag) ->
      currentIds = @get('selectedTagsIds')
      tagId = Number(tag.get('id'))

      if currentIds.includes(tagId)
        currentIds.splice(currentIds.indexOf(tagId), 1)
      else
        currentIds.push(tagId)

      tag.set('active', not tag.get('active'))
      @set('isActionsDisabled', currentIds.length <= 0)
    
    groupTagAction: (isDelete) ->
      currentIds = @get('selectedTagsIds')
      action = unless isDelete then 'add_tag_ids' else 'delete_tag_ids'  
      data = {}
      data[action] = currentIds
      @set('isLoading', true)
      @set('selectedTagsIds', [])
      @set('isActionsDisabled', true)
      @get('clientTags').forEach (tag) => tag?.set('active', false)
      @sendAction('close', data)



      

